import { render, staticRenderFns } from "./DevicesPage.vue?vue&type=template&id=4163100c&scoped=true"
import script from "./DevicesPage.vue?vue&type=script&lang=js"
export * from "./DevicesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4163100c",
  null
  
)

export default component.exports